import { rollbar } from './rollbar';

declare global {
  interface Window {
    dataLayer: any;
    ga: any;
  }
}

function trackEvent({ event, section, link }: { event: string; section: string; link: string }) {
  if (!(event && section && link)) {
    rollbar.error('Analytics event missing required attributes', {
      event,
      section,
      link,
    });
    return;
  }

  if (window.ga) {
    window.ga('send', 'event', event, section, link);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    click_section: section,
    click_link: link,
  });
}

export function trackAnalyticsEvent(event: MouseEvent) {
  const target = event.currentTarget as HTMLElement;
  if (!target) return;

  const category = target.getAttribute('data-category')?.toLowerCase() ?? 'meganav';
  const section = target.getAttribute('data-section')?.toLowerCase();
  const link = target.getAttribute('data-link');

  if (!(category && section && link)) {
    rollbar.error('HTMLElement is missing required analytics tracking attributes', {
      category,
      section,
      link,
    });
    return;
  }

  trackEvent({
    event: category,
    section,
    link,
  });
}
